var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.1293L4.54753 21.5817C4.26869 21.8606 3.91381 22 3.48289 22C3.05196 22 2.69708 21.8606 2.41825 21.5817C2.13942 21.3029 2 20.948 2 20.5171C2 20.0862 2.13942 19.7313 2.41825 19.4525L9.87072 12L2.41825 4.54753C2.13942 4.26869 2 3.91381 2 3.48289C2 3.05196 2.13942 2.69708 2.41825 2.41825C2.69708 2.13942 3.05196 2 3.48289 2C3.91381 2 4.26869 2.13942 4.54753 2.41825L12 9.87072L19.4525 2.41825C19.7313 2.13942 20.0862 2 20.5171 2C20.948 2 21.3029 2.13942 21.5817 2.41825C21.8606 2.69708 22 3.05196 22 3.48289C22 3.91381 21.8606 4.26869 21.5817 4.54753L14.1293 12L21.5817 19.4525C21.8606 19.7313 22 20.0862 22 20.5171C22 20.948 21.8606 21.3029 21.5817 21.5817C21.3029 21.8606 20.948 22 20.5171 22C20.0862 22 19.7313 21.8606 19.4525 21.5817L12 14.1293Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.5da2feafca39dafc28774c85a00c9277.svg";
export { ForwardRef as ReactComponent };